<div class="modal-container">
  @if (showHeader()) {
    <div class="modal-header p-4" [class.no-divider]="noDivider()">
      @if (header()) {
        <ng-container [ngTemplateOutlet]="header()"></ng-container>
      } @else {
        <div class="d-flex justify-content-between">
          <lbt-text typography="body1" color="gray-12" [bold]="true">
            {{modalTitle()}}
          </lbt-text>
          @if (showCloseIcon()) {
            <lbt-icon mat-dialog-close class="pointer" size="slg">close</lbt-icon>
          }
        </div>
      }
    </div>
  }
  <div class="modal-body">
    @if (body()) {
      <ng-container [ngTemplateOutlet]="body()"></ng-container>
    }
  </div>
  @if (footer()) {
    <div class="modal-footer">
      <ng-container [ngTemplateOutlet]="footer()"></ng-container>
    </div>
  }
</div>

